// extracted by mini-css-extract-plugin
module.exports = {"thumbInfo":"thumb-info-hashed__thumbInfo__35j9n"};